import { Button, Checkbox } from 'antd';
import styled from 'styled-components';

export const ModalHeader = styled.div`
  background-color: #f78e1e;
  color: white;
  padding: 16px 24px;
  margin: -20px -24px 20px -24px;
  font-size: 18px;
  font-weight: 500;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 8px;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-left: 0 !important;

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #f78e1e;
    border-color: #f78e1e;
  }

  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #f78e1e;
  }

  .ant-checkbox-checked::after {
    border-color: #f78e1e;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
`;

export const CancelButton = styled(Button)`
  min-width: 100px;
`;

export const ExportButton = styled(Button)`
  min-width: 140px;
  background-color: #f78e1e;
  border-color: #f78e1e;

  &:hover,
  &:focus {
    background-color: #e07a15;
    border-color: #e07a15;
  }
`;
